import { useEffect, useState } from 'react';

// Below Tailwind's `md` breakpoint (768px). Used to render phone-friendly
// card layouts instead of wide tables. We render ONE layout at a time
// (rather than CSS show/hide) so the DOM isn't duplicated — that keeps the
// accessibility tree clean and avoids double matches in tests.
const COMPACT_QUERY = '(max-width: 767px)';

function readMatch(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(COMPACT_QUERY).matches;
}

/** True on phone-width viewports. Falls back to `false` (wide layout). */
export function useIsCompact(): boolean {
  const [isCompact, setIsCompact] = useState(readMatch);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(COMPACT_QUERY);
    const onChange = () => setIsCompact(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isCompact;
}
